import styled from "styled-components";
export const TabSubTitle = styled.label `
  ${({ disabled, theme }) => {
    if (disabled) {
        return `color: rgba (${theme.colors.transparentBlack}, 0.26)`;
    }
    return `color: ${theme.colors.grey13};`;
}};
  ${({ theme }) => `font-size: ${theme.fontTokens.font14[0]};`}
  ${({ disabled }) => `cursor: ${disabled ? "default" : "pointer"};`}
`;
